import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../middleware/dataSlice';
import {
  ApiResponse,
  Menu,
  Role,
  RolesToEndpoint,
  RolesToEndpointResponse,
  AssignRoleEndpoint,
  HasRolePermissionToComponent
} from '../types/authorization.types';

export const authorizationAPI = createApi({
  reducerPath: 'authorizationAPI',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Authorization', 'Roles'],
  endpoints: (builder) => ({
    getAuthorizeDefinitionEndpoints: builder.query<ApiResponse<Menu[]>, void>({
      query: () => ({
        url: '/Authorization/GetAuthorizeDefinitionEndpoints',
        method: 'GET',
      }),
      providesTags: ['Authorization'],
    }),

    getRolesToEndpoint: builder.mutation<ApiResponse<RolesToEndpointResponse[]>, RolesToEndpoint>({
      query: (data) => ({
        url: '/Authorization/GetRolesToEndpoint',
        method: 'POST',
        body: data,
      }),
    }),

    assignRoleEndpoint: builder.mutation<ApiResponse<any>, AssignRoleEndpoint>({
      query: (data) => ({
        url: '/Authorization/AssignRoleEndpoint',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Authorization'],
    }),

    hasRolePermissionToComponent: builder.mutation<ApiResponse<boolean>, HasRolePermissionToComponent>({
      query: (data) => ({
        url: '/Authorization/HasRolePermissionToComponent',
        method: 'POST',
        body: data,
      }),
    }),
    getRolesForPage: builder.query<ApiResponse<Role[]>, string>({
      query: (companyId) => ({
        url: `Roles/GetRolesForPage?companyName=${companyId}`,
        method: 'GET',
      }),
      providesTags: ['Roles'],
    }),
  }),
});

export const {
  useGetAuthorizeDefinitionEndpointsQuery,
  useGetRolesToEndpointMutation,
  useAssignRoleEndpointMutation,
  useHasRolePermissionToComponentMutation,
  useGetRolesForPageQuery,
} = authorizationAPI;
